import React from 'react'

import get from 'lodash/get'
import moment from 'moment'

import {
  AutoComplete,
  DatePicker,
  MenuItem,
  TextField,
  SelectField,
  Chip
} from 'material-ui'

const Filters = (props) => (
  <div>
    {props.filters.filter(f => f.enabled).map((filter, i) => {
      const val = get(props.values, filter.prop)

      if (filter.type === 'text') {
        return (
          <TextField
            key={filter.name}
            value={val || ''}
            floatingLabelText={filter.name}
            onChange={props.handleFilterTextChange.bind(null, filter)}
            style={{ marginRight: '1em' }}
          />
        )
      }

      if (filter.type === 'autocomplete') {
        return (
          <AutoComplete
            key={filter.name}
            floatingLabelText={filter.name}
            dataSource={props.autocompleteResults[filter.references] || []}
            dataSourceConfig={{ text: filter.displayProp || filter.referenceProp, value: 'id' }}
            onNewRequest={props.handleAutocompleteSelection.bind(null, filter)}
            filter={() => true}
            searchText={props.autocompleteText[filter.references]}
            onUpdateInput={props.handleAutocompleteUpdateInput.bind(null, filter)}
            style={{ marginRight: '1em' }}
          />
        )
      }

      if (filter.type === 'datepicker') {
        return (
          <DatePicker
            firstDayOfWeek={0}
            key={filter.name}
            value={val
              ? moment(val).toDate() // use moment date parser to avoid incorrect date display
              // https://github.com/mui-org/material-ui/issues/9301
              : null}
            floatingLabelText={filter.name}
            container='inline'
            mode='landscape'
            autoOk
            onChange={props.handleDatePickerUpdate.bind(null, filter)}
            style={{ display: 'inline-block', marginRight: '1em' }}
          />
        )
      }

      if (filter.type === 'select') {
        return (
          <SelectField
            key={filter.name}
            value={val}
            floatingLabelText={filter.name}
            onChange={props.handleFilterSelectChange.bind(null, i, filter)}
            style={{ display: 'inline-block', float: 'left', marginRight: '1em' }}
          >
            <MenuItem value={null} primaryText='All' />
            {filter.items.map(item => (
              <MenuItem key={item.prop} value={item.prop} primaryText={item.title} />
            ))}
          </SelectField>
        )
      }

      if (filter.type === 'multipleSelect') {
        return (
          <SelectField
            multiple
            hintText={filter.name}
            value={val}
            onChange={props.handleFilterMultipleSelectChange.bind(null, filter)}
            style={{ display: 'block', width: '100%', marginTop: 24, marginRight: '1em' }}
            selectionRenderer={values => {
              return <div style={{ display: 'flex' }}>
                {values.map(value => (
                  <Chip
                    key={value}
                    onRequestDelete={props.handleFilterMultipleSelectChipDelete.bind(null, filter, val, value)}
                    style={{ margin: 4 }}
                  >
                    {
                      filter.items.find(item => {
                        return item.prop === value
                      }).title
                    }
                  </Chip>
                ))}
              </div>
            }}
          >
            {filter.items.map(item => (
              <MenuItem
                key={item.prop}
                insetChildren
                checked={val && val.indexOf(item.prop) > -1}
                value={item.prop}
                primaryText={item.title}
              />
            ))}
          </SelectField>
        )
      }

      if (filter.type === 'break') {
        return (<div key={i} />)
      }
    })}
  </div>
)

// @ts-ignore
Filters.propTypes = {
  values: React.PropTypes.object.isRequired,
  filters: React.PropTypes.arrayOf(React.PropTypes.shape({
    name: React.PropTypes.string,
    prop: React.PropTypes.string,
    type: React.PropTypes.oneOf(['text', 'autocomplete', 'multipleSelect', 'bool', 'datepicker', 'select', 'break']).isRequired,
    enabled: React.PropTypes.bool.isRequired
  })).isRequired,
  handleFilterTextChange: React.PropTypes.func.isRequired,
  handleAutocompleteSelection: React.PropTypes.func.isRequired,
  handleAutocompleteUpdateInput: React.PropTypes.func.isRequired,
  handleDatePickerUpdate: React.PropTypes.func.isRequired,
  handleFilterMultipleSelectChange: React.PropTypes.func.isRequired,
  handleFilterMultipleSelectChipDelete: React.PropTypes.func.isRequired,
  autocompleteText: React.PropTypes.object.isRequired,
  autocompleteResults: React.PropTypes.object.isRequired
}

export default Filters
